import { Edit, SimpleForm, useRecordContext } from "react-admin";
import { RazaBackedEventFormFields } from "@/components/raza/RazaBackedEventFormFields";
import { isOhbatRazaEvent } from "@/utils/raza-event-display";
import {
  stripReadOnlyOhbatEventFields,
  stripReadOnlyRazaEventFields,
} from "@/utils/raza-request-event-payload";
import { RazaEventOhbatFormFields } from "./RazaEventOhbatFormFields";

function RazaEventEditForm() {
  const record = useRecordContext();
  const isOhbat = record ? isOhbatRazaEvent(record) : true;

  return (
    <SimpleForm warnWhenUnsavedChanges sx={{ maxWidth: 1120 }}>
      {isOhbat ? <RazaEventOhbatFormFields /> : <RazaBackedEventFormFields />}
    </SimpleForm>
  );
}

const RazaEventOhbatEdit = () => (
  <Edit
    redirect="show"
    transform={(data: Record<string, unknown>) =>
      isOhbatRazaEvent(data)
        ? stripReadOnlyOhbatEventFields(data)
        : stripReadOnlyRazaEventFields(data)
    }
  >
    <RazaEventEditForm />
  </Edit>
);

export default RazaEventOhbatEdit;
